import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

export default function EditorialMarquee() {
  const { t } = useLang();
  const text = t.marquee;
  return (
    <div data-testid="marquee" className="bg-surface border-y border-sandborder py-6 md:py-8 overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill>
        <span className="font-playfair italic text-navy text-3xl md:text-5xl px-4">
          {text}
        </span>
      </Marquee>
    </div>
  );
}
